import MDataCard from './index.vue';

MDataCard.install = app => {
  app.component(MDataCard.name, MDataCard);
};

export default MDataCard;
